import { render } from "./SustainabilityTargets.vue?vue&type=template&id=26a8b3ec&scoped=true"
import script from "./SustainabilityTargets.vue?vue&type=script&lang=js"
export * from "./SustainabilityTargets.vue?vue&type=script&lang=js"

import "./SustainabilityTargets.vue?vue&type=style&index=0&id=26a8b3ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a8b3ec"]])

export default __exports__